import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
import { ListLogOperazioneDTO } from 'src/app/model/newModel';

import { SharedService } from '../../../../shared/shared.service';
import { LogOperazioneService } from '../../log-operazione/log-operazione.service';

@Component({
  selector: 'app-carica-voti-prova-finale',
  templateUrl: './carica-voti-prova-finale.component.html',
  styleUrls: ['./carica-voti-prova-finale.component.css'],
})
export class CaricaVotiProvaFinaleComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  // COMBO BOX

  submitted = false;

  showLogOperazione: boolean;
  listLogOperazione: ListLogOperazioneDTO;


  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    public router: Router,
    private sharedService: SharedService,
    private spinner: NgxSpinnerService,
    private logOperazioneService: LogOperazioneService
  ) {
    super();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.getLogOperazione(null);
  }

  verifyFile(file: File, event: any) {
    if (file && file.name.indexOf('.csv') <= 0) {
      this.sharedService.openKoModal();
    } else {
      this.spinner.show();
      setTimeout(() => {
        this.spinner.hide();
        this.sharedService.openOkModal();
      }, 20000);
      this.modalSubscribe = this.ngxSmartModalService
      .getModal('okModal')
      .onClose.subscribe((modal: NgxSmartModalComponent) => {
        window.location.reload();
      });
    }
  }

  getLogOperazione(idUtente: string) {
    this.spinner.show();
    const idTipoOperazione = "ERRORE CARICAMENTO VOTI";
    this.logOperazioneService.search(null, idTipoOperazione).subscribe(
      (result) => {

        const listLogResult = result;
        if (!!listLogResult  && !!listLogResult.logOperazioni && listLogResult.logOperazioni.length > 0) {
          this.listLogOperazione = listLogResult;
          this.showLogOperazione = true;
        } else {
          this.showLogOperazione = false;
        }
        this.spinner.hide();
      },
      (error) => {
        console.log('Errore search');
        this.spinner.hide();
      }
    );
  }

}
